import React from "react";
import Wait from "../wait";
import CollectService from "../../service/v1/collect";
import GeneralSelect from "../general_select";
import CreateService from "../../service/create";


export default class AddDodosoPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            zoneOptions: {
                endpoint: 'projects/team-members/' + this.props.project.id,
                value: 'id',
                label: 'fullname',
                placeholder: 'Select Team Member'
            },
            forms: [],
            form_fields: [],
            localityOption: {
                endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') ,
                value: 'id',
                label: 'name',
                placeholder: 'Select ...'
            },
            regionOption: {
                endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') ,
                value: 'id',
                label: 'name',
                placeholder: 'Select Region'
            },
            is_district_disabled: true,
            field_answers: [],
            field_ids: [],
            files_selected: [],
        }


        this.loadQuestions = this.loadQuestions.bind(this)
        this.showFormFieldsAt = this.showFormFieldsAt.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        this.submit = this.submit.bind(this)

    }


    loadQuestions(id, i = 0, j = 0) {
        try {
            Wait.show('Fetching Forms........')
            document.getElementById('tr_answer').style.visibility = 'visible'
            CollectService.fetchQuestionsForms(this.props.project.id, parseInt(id), 0).then(r => {
                try {
                    Wait.dismiss()
                    console.log(r.data.results[i].form_fields)
                    this.setState({
                        title: r.data.results[i].name,
                        forms: r.data.results,
                        form_fields: r.data.results[i].form_fields,
                        current_menu: i,
                        current_tab: j
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }
    }

    showFormFieldsAt(i) {
        this.setState({
            title: this.state.forms[i].name,
            form_fields: this.state.forms[i].form_fields,
            current_menu: i
        })
    }


    saveAnswer(e,d){
        let response = e.target.value
        if (e.target.type === 'file') {
            console.log('HSHSHSHSHSH')
            this.setState(prevState => {
                console.log(prevState.files_selected.indexOf(d.id))
                //if (prevState.files_selected.indexOf(d.id) === -1){
                    console.log(prevState.files_selected.indexOf(d.id) > -1)
                    let file = {'file': e.target.files[0], 'd' : d}
                    let files = [...prevState.files_selected, file];
                    return {
                        files_selected: files,
                    };
                //}
            });
        } else {
            this.setState(prevState => {
                console.log(prevState.field_ids.indexOf(d.id))
                if (prevState.field_ids.indexOf(d.id) === -1){
                    console.log(prevState.field_ids.indexOf(d.id) > -1)
                    let field_ids = [...prevState.field_ids, d.id];
                    return {
                        field_ids: field_ids,
                    };
                }
            });
        }
    }

    generalSelect(data, name) {
        let response = data.value
        this.setState(prevState => {
            let field_answers = [...prevState.field_answers, {form_field_id: name.id, response: response}];
            return {
                field_answers: field_answers,
            };
        });
        let ids = []

        switch (name.data_type) {
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break
            case 'council':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break

        }
        console.log(data)
    }

    render() {
        return (<div>
            <div className={'row'}>
                <div>

                    {this.props.questionnaires.map((d, i) => {
                        return (<div key={i} className={i === this.state.current_tab ? 'tab tab-active' : 'tab'}
                                     style={{width: '300px'}}
                                     onClick={() => this.loadQuestions(d.id, 0, i)}>
                            {d.name}
                        </div>)
                    })}

                    {/*<select style={{width:'100%',fontWeight:'bold',fontSize:'18px'}} >
                        <option>-Choose Questionnaire-</option>

                    </select>*/}
                </div>
            </div>

            <div className={'row'} style={{fontSize: '20px', visibility: 'hidden'}} id={'tr_answer'} >
                <div className={'col col-sm-3'} style={{borderRight: '1px dashed #ccc', padding: 0,overflow:"auto", height: '85vh'}}>
                    <div style={{background: 'linear-gradient(#fff,#ccc)', padding: '8px'}}>
                        <span className={'fa fa-question-circle'}/>Questions
                    </div>
                    <br/>

                    {this.state.forms.map((d, i) => {
                        return (<div onClick={() => this.showFormFieldsAt(i)}
                                     className={i === this.state.current_menu ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}
                                     key={i} title={d.name}>{d.name}</div>)
                    })}
                </div>
                <div className={'col col-sm-9'}>

                    <div
                        style={{background: 'linear-gradient(#fff,#ccc)', borderTop: '1px solid #ccc', padding: '8px'}}>
                        <span className={'fa fa-question-circle-o'}/>{this.state.title} - {this.props.villagename}
                    </div>

                    <div style={{overflowY: 'auto', height: '75vh', padding: '24px', border: '1px solid #ccc'}}>

                        <table style={{width: '100%', marginTop: '8px'}}>
                            <tbody>
                            {this.state.form_fields.map((d, i) => {
                                return (<tr id={'tr_' + d.parent} key={'tr_' + d.form_field + '_' + d.parent}
                                            style={{display: d.parent !== 0 ? 'none' : 'table-row'}}>
                                    <td style={{
                                        width: '300px',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>{d.form_field}</td>
                                    <td style={{fontSize: '18px'}}>
                                        <div style={{color: '#888'}}> {d.hint}</div>

                                        {d.data_type === 'select' || d.data_type === 'radio' ?
                                            <select style={{width: '91%'}} name={d.form_field}
                                                    onChange={(e) => this.saveAnswer(e, d)} id={d.id}>
                                                <option>- Choose One -</option>
                                                {d.options.split(',').map((o, j) => {
                                                    return (<option key={j}>{o}</option>)
                                                })}
                                            </select> :
                                            d.data_type === 'hamlet' ||
                                            d.data_type === 'village' ||
                                            d.data_type === 'ward' ||
                                            d.data_type === 'council' ?/*<select style={{width:'91%'}} name={d.form_field} onChange={(e)=>this.saveAnswerAt(e,d)}>
                                                <option>- Choose {d.form_field} -</option>
                                                <option value={1}>Sample {d.form_field}</option>
                                            </select>*/
                                                <GeneralSelect onChanges={(e) => this.generalSelect(e, d)}
                                                               parameters={this.state.localityOption} isDisable={this.state.is_district_disabled}/>

                                                :
                                                d.data_type === 'region' ?
                                                    <GeneralSelect onChanges={(e) => this.generalSelect(e, d)}
                                                                   parameters={this.state.regionOption}/>
                                                    :
                                                    d.data_type === 'text_large' ?
                                                        <textarea rows={6} style={{width: '90%'}}
                                                                  onChange={(e) => this.saveAnswer(e, d)}/> :
                                                        d.data_type === 'team_member' ? <GeneralSelect
                                                                onChanges={(e) => this.generalSelect(e, d)}
                                                                parameters={this.state.zoneOptions}/> :
                                                            <input type={d.data_type} key={d.form_field} id={d.id}
                                                                   style={{width: '90%'}} placeholder={d.data_type}
                                                                   name={d.form_field}
                                                                   onChange={(e) => this.saveAnswer(e, d)}/>
                                        }
                                        {/*<div style={{color:'#f00'}}> {d.error_message}</div>*/}
                                    </td>
                                </tr>)
                            })}
                            <tr>
                                <td/>
                                <td>
                                    <button className={'btn'} onClick={() => this.submit()}>
                                        <span className={'fa fa-save'}/>Submit
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>

        </div>);
    }


    submit(){
        let count = 0
        this.state.field_ids.map((d, i)=>{
            console.log(d)
            let a = document.getElementById(d)
            console.log(a.value)
            let value = a.value
            if (a.options !== undefined){
                value = a.options[a.selectedIndex].text
            }
            try {
                CollectService.createAnswer({
                    project_id: this.props.project.id,
                    is_monitoring: 1,
                    claim_no: JSON.parse(sessionStorage.getItem('decoded')).user_id + '-' +  this.props.project.id,
                    form_field_id: d,
                    file: '',
                    document_type_id: process.env.REACT_APP_DODOSO_DOC_TYPE_ID,
                    task_id: this.props.task_id,
                    description: '',
                    response: value
                }).then(r => {
                    console.log(r.data)
                    if (r.data.status === 201){
                        count++
                    }
                })
            } catch (e) {
                console.log(e)
            }
        })

        this.state.field_answers.map((d, i)=>{
            console.log(d)
            try {
                CollectService.createAnswer({
                    project_id: this.props.project.id,
                    is_monitoring: this.props.project.project_type_info.name.toString().toLowerCase().includes("monitoring")
                        ? 1 : 0,
                    claim_no: JSON.parse(sessionStorage.getItem('decoded')).user_id + '-' +  this.props.project.id,
                    form_field_id: d.form_field_id,
                    response: d.response,
                    file: '',
                    document_type_id: process.env.REACT_APP_DODOSO_DOC_TYPE_ID,
                    task_id: this.props.task_id,
                    description: ''
                }).then(r => {
                    console.log(r.data)
                    count++
                })
            } catch (e) {
                console.log(e)
            }
        })

        this.state.files_selected.map((d, i)=>{
            console.log(d)
            try {
                let formdata = new FormData()
                formdata.append('project_id',this.props.project.id)
                formdata.append('is_monitoring',1)
                formdata.append('claim_no',JSON.parse(sessionStorage.getItem('decoded')).user_id
                    + '-' +  this.props.project.id)
                formdata.append('file',d.file)
                formdata.append('form_field_id', d.d.id)
                formdata.append('response','')
                formdata.append('document_type_id', process.env.REACT_APP_DODOSO_DOC_TYPE_ID)
                formdata.append('task_id',this.props.task_id)
                formdata.append('description', d.d.form_field)

                CreateService.uploadFile('collect/questionnaires/create/answer',  formdata).then(r => {
                    console.log('Data upload result')
                    console.log(r.data)
                    count++
                })
            } catch (e) {
                console.log(e)
            }
        })
        this.setState({
            field_answers: [],
            field_ids: [],
            files_selected: []
        })
        alert("success")
    }
}















